import { ChangeEventHandler, VFC } from 'react';
import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  asterisk: {
    '& .MuiFormLabel-asterisk': {
      fontSize: '1.5rem', // ここでサイズを設定
      color: '#bb5535',       // 必要に応じて色も変更可能
    },
  },
}));

type Props = {
  fullWidth: boolean;
  label: string;
  multiline: boolean;
  required: boolean;
  rows: number;
  value: string | number;
  type: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
};

// 使い回しできるtextboxのコンポーネント
export const TextInput: VFC<Props> = (props) => {
  const classes = useStyles();
  const { fullWidth, label, multiline, required, rows, value, type, onChange } =
    props;

  return (
    <TextField
      className={required ? classes.asterisk : ''}
      fullWidth={fullWidth} // trueなら全幅
      label={label} // ラベル
      margin='dense'
      multiline={multiline} // 複数行か
      required={required} // 必須か
      minRows={rows} // 複数行の場合の行数
      value={value}
      type={type}
      onChange={onChange}
    />
  );
};
